import React, { ReactNode } from "react";
import { Modal } from "antd";

interface CustomConfirmModalProps {
  open: boolean;
  title: string;
  element?: ReactNode;
  description?: string;
  note?: string;
  onOk?: () => void;
  onCancel: () => void;
  okText?: string;
  hideOk?: boolean;
  cancelText?: string;
  okButtonBgColor?: string;
}

const CustomConfirmModal: React.FC<CustomConfirmModalProps> = ({
  open,
  title,
  element,
  description,
  note,
  onOk,
  onCancel,
  okText = "OK",
  hideOk = false,
  cancelText = "Cancel",
  okButtonBgColor,
}) => {
  return (
    <Modal
      open={open}
      onOk={onOk}
      onCancel={onCancel}
      footer={null}
      closable={false}
      centered
      width={600}
      className="!p-0 !rounded-[30px] !shadow-[0px_0px_15px_0px_rgba(0,0,0,0.05)] !outline !outline-8 !outline-offset-[-8px] !outline-white"
    >
      <div className="md:px-10 md:py-16 flex flex-col justify-center items-center gap-10 overflow-hidden">
        <div className="w-full flex flex-col justify-start items-center gap-7">
          <div className="w-full flex flex-col justify-start items-start gap-5">
            <div className="w-full whitespace-pre-line text-center text-primary text-[22px] md:text-3xl font-bold font-['Noto_Sans_JP'] leading-10">
              {title}
            </div>
            {element}
            <div className="w-full text-center text-black text-[15px] md:text-base font-normal font-['Noto_Sans_JP'] leading-relaxed whitespace-pre-line">
              {description}
              <div className="self-stretch inline-flex flex-col justify-start items-start gap-[5px]">
                <div className="self-stretch text-center justify-start text-black text-[11px] md:text-[12px] font-normal font-['Noto_Sans_JP'] leading-tight">
                  {note}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="w-full flex flex-col justify-start items-center gap-3.5">
          {!hideOk && (
            <button
              onClick={onOk}
              className={`w-80 min-h-14 px-5 py-2.5 rounded-md flex justify-center items-center text-white text-lg font-bold font-['Noto_Sans_JP'] leading-7 ${
                okButtonBgColor ?? "bg-primary"
              }`}
            >
              {okText}
            </button>
          )}
          <button
            onClick={onCancel}
            className="text-primary text-sm font-medium font-['Noto_Sans_JP'] underline leading-snug"
          >
            {cancelText}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default CustomConfirmModal;
